export function replaceMacros(sectionData, websiteData, url) {
  if (!websiteData) return false;
  if (!sectionData) sectionData = {};

  let macros = websiteData;

  let sectionDataFunction = {};

  Object.keys(sectionData).forEach(key => {
    if (typeof sectionData[key] === 'function') {
      sectionDataFunction = { ...sectionDataFunction, [key]: sectionData[key] };
    }
  });

  //Add to macros all the query params from the url object
  url.searchParams.forEach((value, key) => {
    macros[key] = value;
  });

  let sectionString = JSON.stringify(sectionData);

  //Reserverd macro stars render svg
  sectionString = sectionString.replaceAll(
    '{%stars%}',
    `<span class='inline-flex flex-row items-center vertical-middle' style='gap:2px;'>` +
      `<svg xmlns='http://www.w3.org/2000/svg' width='0.8em' height='0.8em' viewBox='0 0 16 16' fill='none'><g clip-path='url(#clip0_1_696)'><path d='M8 0L10.2744 5.32171L16 5.85681L11.68 9.68091L12.9443 15.3333L8 12.375L3.05573 15.3333L4.32 9.68091L0 5.85681L5.72564 5.32171L8 0Z'fill='var(--color-fill-rating)'/></g><defs><clipPath id='clip0_1_696'><rect width='16' height='16' fill='white' /></clipPath></defs></svg>` +
      `<svg xmlns='http://www.w3.org/2000/svg' width='0.8em' height='0.8em' viewBox='0 0 16 16' fill='none'><g clip-path='url(#clip0_1_696)'><path d='M8 0L10.2744 5.32171L16 5.85681L11.68 9.68091L12.9443 15.3333L8 12.375L3.05573 15.3333L4.32 9.68091L0 5.85681L5.72564 5.32171L8 0Z'fill='var(--color-fill-rating)'/></g><defs><clipPath id='clip0_1_696'><rect width='16' height='16' fill='white' /></clipPath></defs></svg>` +
      `<svg xmlns='http://www.w3.org/2000/svg' width='0.8em' height='0.8em' viewBox='0 0 16 16' fill='none'><g clip-path='url(#clip0_1_696)'><path d='M8 0L10.2744 5.32171L16 5.85681L11.68 9.68091L12.9443 15.3333L8 12.375L3.05573 15.3333L4.32 9.68091L0 5.85681L5.72564 5.32171L8 0Z'fill='var(--color-fill-rating)'/></g><defs><clipPath id='clip0_1_696'><rect width='16' height='16' fill='white' /></clipPath></defs></svg>` +
      `<svg xmlns='http://www.w3.org/2000/svg' width='0.8em' height='0.8em' viewBox='0 0 16 16' fill='none'><g clip-path='url(#clip0_1_696)'><path d='M8 0L10.2744 5.32171L16 5.85681L11.68 9.68091L12.9443 15.3333L8 12.375L3.05573 15.3333L4.32 9.68091L0 5.85681L5.72564 5.32171L8 0Z'fill='var(--color-fill-rating)'/></g><defs><clipPath id='clip0_1_696'><rect width='16' height='16' fill='white' /></clipPath></defs></svg>` +
      `</span>`,
  );

  Object.keys(macros).forEach(key => {
    sectionString = sectionString.replaceAll('{%' + key + '%}', macros[key]);
  });

  //Replace all the remaining macros with an empty string
  sectionString = sectionString.replace(/{%.*?%}/g, '');

  let section = JSON.parse(sectionString);
  return { ...section, ...sectionDataFunction };
}

export function handleInputMacros(wrapper: HTMLElement) {
  const input = wrapper.querySelector('input');

  if (!input) return;
  //Append style to document
  const style = document.createElement('style');
  style.innerHTML = `
    .input-overlay {
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
      white-space: pre;
      display: block;
      width: 100%;
      padding: 10px var(--spacing-micro);
      color: inherit;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0.14px;
      border: 1px solid rgba(0,0,0,0);
    }
    .macro-tag {
      background-color: #ff0;
    }
  `;
  document.head.appendChild(style);
  //Append overlay to inputWrapper
  const overlay = document.createElement('div');
  overlay.className = 'input-overlay';
  wrapper.appendChild(overlay);

  input.addEventListener('input', handleInput);
}

function handleInput() {
  const input = this;
  const overlay = input.parentElement.querySelector('.input-overlay');
  const regex = /{%.*?%}/g;

  // Escape HTML special characters
  const escapeHtml = text =>
    text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  let innerHTML = escapeHtml(input.value);
  let match = null;

  while ((match = regex.exec(input.value)) !== null) {
    // Wrap matched text with a highlight span (you can style this as needed)
    match[0] = match[0]
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    innerHTML =
      innerHTML.substring(0, match.index) +
      '<span class="macro-tag">' +
      escapeHtml(match[0]) +
      '</span>' +
      innerHTML.substring(match.index + match[0].length, innerHTML.length);
  }

  overlay.innerHTML = innerHTML;
}
